import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { compareDesc } from "date-fns";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useDispatch } from "react-redux";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import { columns } from "../../static-models/CorporateLogs";
import useButtonStyles from "../../styles/useButtonStyles";
import { getEncodedValue } from "../forms/utility";
import formatDate from "../../util/dateFormat";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import ViewCorporateUser from "./ViewCorporateUser";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { corporateListActions } from "../../redux/slices/corporateSlice";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  DateConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
export interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
  dropdownOptions?: string[];
  isCheckbox?: boolean;
}

const CorporateLogs = () => {
  const corporateList = useAppSelector(
    (state) => state.persistReducers.corporateSlice.corporateList
  );
  const [openFilter, setOpenFilter] = useState(false);
  const [viewCorpUser, setViewCorpUser] = useState(false);
  const [corpUser, setCorpUser] = useState<any>([]);
  const [singleCorporateLog, setSingleCorporateLog] = useState<any>([]);
  const [filterActive, setFilterActive] = useState(false);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [lastKey, setlastKey] = useState(null);
  const [isApiCall, setIsApiCall] = useState(true);

  const dispatch = useDispatch();
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  const theme = useTheme();
  const buttonStyles = useButtonStyles();
  const navigate = useNavigate();
  const searchInputRef = useRef<HTMLInputElement>();

  const params = useParams();
  const { corporateId } = params;
  useEffect(() => {
    if (corporateId) {
      const corpUser = corporateList.filter(
        (corp: any) => corp.id === corporateId
      );
      const corporateLogs = corpUser[0];
      setSingleCorporateLog(corporateLogs);
      setViewCorpUser(true);
    }
  }, [corporateId]);

  const responseDate = (data: any) => {
    return JSON.parse(data);
  };
  const fetchData = async (canHaveExistingData?: boolean) => {
    setLoadingAPI(true);
    let url = `${process.env.REACT_APP_API_URL}${APIConstants.getCorporateLog}`;
    const filters = getSearchAndFilterParams();
    if (filters) url += "?" + filters;
    try {
      getTotalRecordsCount(APIModuleConstants.corporateLogs, filters);
      if (lastKey) {
        url +=
          (filters ? "&" : "?") +
          `lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }
      const response = await axios.get(url);
      const lastKeyData = response?.data.result?.data?.lastKey;
      setlastKey(lastKeyData ? lastKeyData : null);
      const newData = response.data.result.data.value;

      const mData = newData.map((item: any) => {
        const reqData = responseDate(item.req);
        const resData = responseDate(item.res);
        if (item.activity === "Corporate User Profile Created") {
          return {
            firstName: reqData.first_name ? reqData.first_name : "-",
            lastName: reqData.last_name ? reqData.last_name : "-",
            gender: reqData.gender ? reqData.gender : "-",
            occupation: reqData.occupation ? reqData.occupation : "-",
            Status: item.customer_status ? item.customer_status : "-",
            streetAddress: reqData.address_one
              ? `${reqData.address_one}, ${reqData.address_two}`
              : "-",
            zipCode: reqData.zip ? reqData.zip : "-",
            country: reqData.country_of_residence
              ? reqData.country_of_residence
              : "-",
            birthDate: item.dob_date ? item.dob_date : "-",
            companyName: reqData.company_name ? reqData.company_name : "-",
            officeBuilding: reqData.office_building
              ? reqData.office_building
              : "-",

            id: item.access_id ? item.access_id : "-",
            memberName: item.member_name ? item.member_name : "-",
            access_id: item.access_id ? item.access_id : "-",
            email: item.corporate_email ? item.corporate_email : "-",
            mobile: item.mobile ? item.mobile : "-",
            activity: item.activity ? item.activity : "-",
            suntecEmail: item.target ? item.target : "-",
            issueDate: item.issue_date ? formatDate(item.issue_date) : "-",
            expiryDate: item.expiry_date ? formatDate(item.expiry_date) : "-",
            createdDate: item.created_date
              ? formatDate(item.created_date)
              : "-",
            navigateTo: item.access_id ? `/corporate/${item.access_id}` : "-",
          };
        } else {
          return {
            firstName: resData.first_name ? resData.first_name : "-",
            lastName: resData.last_name ? resData.last_name : "-",
            gender: resData.gender ? resData.gender : "-",
            occupation: resData.occupation ? resData.occupation : "-",
            Status: item.customer_status
              ? item.customer_status
              : filterConstants.Active,
            streetAddress: resData.address_one
              ? `${resData.address_one} ${resData.address_two}`
              : "-",
            zipCode: resData.zip ? resData.zip : "-",
            country: resData.country_of_residence
              ? resData.country_of_residence
              : "-",
            birthDate: item.dob_date ? item.dob_date : "-",
            companyName: resData.company_name ? resData.company_name : "-",
            officeBuilding: resData.office_building
              ? resData.office_building
              : "-",

            id: item.access_id ? item.access_id : "-",
            memberName: item.member_name ? item.member_name : "-",
            access_id: item.access_id ? item.access_id : "-",
            email: item.corporate_email ? item.corporate_email : "-",
            mobile: item.mobile ? item.mobile : "-",
            activity: item.activity ? item.activity : "-",
            suntecEmail: item.target ? item.target : "-",
            issueDate: item.issue_date ? formatDate(item.issue_date) : "-",
            expiryDate: item.expiry_date ? formatDate(item.expiry_date) : "-",
            createdDate: item.created_date
              ? formatDate(item.created_date)
              : "-",
            navigateTo: item.access_id ? `/corporate/${item.access_id}` : "-",
          };
        }
      });

      const dataLoaded = canHaveExistingData
        ? [...corpUser, ...mData]
        : [...mData];
      setCorpUser(dataLoaded);
      dispatch(
        corporateListActions.updateCorporateSlice({
          corporateList: dataLoaded,
        })
      );
    } catch (error) {
      setLoadingAPI(false);
    } finally {
      setLoadingAPI(false);
      setIsApiCall(false);
    }
  };

  const [filterState, setFilterState] = useState({
    createDate: "",
  });

  const onResetData = () => {
    setCorpUser([]);
    setlastKey(null);
    setIsApiCall(true);
  };

  const handleReset = () => {
    setFilterStates([]);
    setFilterState({
      createDate: "",
    });
    setFilterActive(false);
    setLoadingAPI(true);
    onResetData();
  };

  useEffect(() => {
    if (isApiCall) {
      fetchData();
    }
  }, [isApiCall]);

  const [filterStates, setFilterStates] = useState<any>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const handleApplyFilterForCorporateLog = () => {
    onResetData();
    setOpenFilter(false);
    filterStates.length && setFilterActive(true);
  };

  const getSearchAndFilterParams = () => {
    const searchValue = searchInputRef.current
      ? searchInputRef?.current.value
      : "";
    const searchdata =
      searchValue.trim() !== "" ? [getEncodedValue(searchValue)] : [];
    const params = {
      searchData: searchdata,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    return url;
  };
  const handleSearch = () => {
    onResetData();
  };
  return (
    <Grid
      borderRadius={"16px"}
      sx={{ background: theme.color?.background }}
      overflow={"hidden"}
    >
      <Grid
        container
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        width={"100%"}
        alignItems={"center"}
      >
        <Grid
          container
          display={"flex"}
          height={"6.25rem"}
          alignItems={"center"}
          justifyContent={"space-between"}
          px={4}
        >
          <Grid>
            <Grid item display={"flex"} alignItems={"center"} gap={2}>
              <Link to="/members">
                <ArrowBackIosIcon sx={{ color: theme.color?.newFilterGrey }} />
              </Link>{" "}
              <Typography
                sx={{
                  fontFamily: theme?.font?.fontFamily.primary,
                  fontWeight: theme.font?.fontWeight.thicker,
                  fontSize: theme.font?.fontSize.large,
                }}
              >
                Corporate Member Logs
              </Typography>
            </Grid>
          </Grid>
          <Grid display={"flex"} gap={3}>
            <SearchInput
              HelpTip={SearchToolTip.CorporateLogs}
              onCallBack={handleSearch}
              ref={searchInputRef}
            />
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{
                color: theme.color?.newFilterGrey,
                textTransform: "capitalize",
              }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid container width={"100%"} px={3}>
        <InfiniteTable
          header={columns}
          contentItems={corpUser}
          hasMoreRecords={lastKey !== null}
          fetchMoreData={() => fetchData(true)}
          isInitialLoading={corpUser.length === 0 && loadingAPI}
          totalRecords={totalCount}
        />
      </Grid>
      <Drawer
        anchor={"right"}
        open={viewCorpUser}
        onClose={() => {
          setViewCorpUser(false);
          navigate("/corporate");
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"40vw"} height={"100%"}>
          <ViewCorporateUser
            corpData={singleCorporateLog}
            closeDrawer={setViewCorpUser}
          />
        </Grid>
      </Drawer>
      <Dialog
        onClose={() => setOpenFilter(false)}
        open={openFilter}
        sx={{ ml: "60vw", mb: "20vh" }}
      >
        <Grid sx={{ width: "483px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Filter
            </Typography>
            <IconButton onClick={() => setOpenFilter(false)}>
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Grid mt={4} display={"flex"} flexDirection={"column"} gap={2}>
              <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Created Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    value={filterState.createDate}
                    onChange={(e) => {
                      getAllFields(
                        "created_date",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        createDate: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
            <Button
              onClick={handleReset}
              sx={{ ...buttonStyles.outlinedSecondary }}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={handleApplyFilterForCorporateLog}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
    </Grid>
  );
};

export default CorporateLogs;
